var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Layer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #83b797 } \n\t\t.s1 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m20 40c11 0 20-9 20-20 0-11-9-20-20-20-11 0-20 9-20 20 0 11 9 20 20 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m16.7 15.4h-3.5v11.6h3.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m24.9 15.7c-1.9 0-2.5 0.7-2.9 1.5v-1.5h-3.5v11.3h3.5v-6.4c0-1 0-1.9 1.7-1.9 1.7 0 1.7 0.9 1.7 1.9v6.4h3.4v-6.4c0-2.9-0.5-4.9-3.9-4.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m14.9 14.6c1 0 1.8-0.8 1.8-1.8 0-1-0.8-1.8-1.8-1.8-0.9 0-1.7 0.8-1.7 1.8 0 1 0.8 1.8 1.7 1.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin1);
export default __webpack_public_path__ + "static/media/linkdin1.ca9d995b3713dff531c30109b7947bcc.svg";
export { ForwardRef as ReactComponent };